import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getClassNameGenerator } from '../../helper/className';
import TextWithTooltip from '../customFormsyElements/TextForLabelWithTooltip';
import ReactTooltip from 'react-tooltip';

const formGroupTooltipClassName = 'form-group-with-tooltip';

const FormGroupLabel = ({ size, isBold, elementId, required, children, className, tooltip }) => (
  <label
    className={classNames({ 'bold-text': isBold }, 'control-label', `col-sm-${size}`, className)}
    htmlFor={elementId}
    required={required}
  >
    {children}

    <TextWithTooltip id={`form-group-tooltip${elementId}`} delayShow={250} display-if={tooltip}>
      { tooltip }
    </TextWithTooltip>
  </label>
);

FormGroupLabel.propTypes = {
  size: PropTypes.number,
  isBold: PropTypes.bool,
  elementId: PropTypes.string,
  className: PropTypes.string,
  required: PropTypes.bool,
  children: PropTypes.any,
  tooltip: PropTypes.any
};

export const FormGroupContent = ({ size, children, className, hint }) => (
  <div className={classNames('clearfix', `col-sm-${size}`, className)}>
    {children}
    <div className={`${className}-hint`} display-if={hint}>{hint}</div>
  </div>
);

FormGroupContent.propTypes = {
  size: PropTypes.number,
  children: PropTypes.any,
  className: PropTypes.string,
  hint: PropTypes.any
};

export const FormGroupCheckboxContent = ({ className, hint, infoTooltip, contentTooltip, children, id, disabled }) => (
  <div
    className={classNames(
      className,
      FormGroupCheckboxContent.className,
      {
        [FormGroupCheckboxContent.getClassName('disabled')]: disabled,
        [formGroupTooltipClassName]: Boolean(infoTooltip)
      }
    )}
  >
    <label className={FormGroupCheckboxContent.getClassName('label')}>
      {children}
      <i
        className={FormGroupCheckboxContent.getClassName('box')}
        {...(contentTooltip ? FormGroupCheckboxContent.getContentTooltipAttrs(id) : {})}
      />
      <ReactTooltip display-if={contentTooltip} effect='solid' id={`checkbox-label-tooltip${id}`}>{contentTooltip}</ReactTooltip>
      <div className={FormGroupCheckboxContent.getClassName('hint')}>{hint}</div>
    </label>

    <TextWithTooltip id={`checkbox-tooltip${id}`} delayShow={250} display-if={infoTooltip}>
      { infoTooltip }
    </TextWithTooltip>
  </div>
);

FormGroupCheckboxContent.propTypes = {
  className: PropTypes.string,
  hint: PropTypes.any,
  infoTooltip: PropTypes.any,
  contentTooltip: PropTypes.any,
  children: PropTypes.any,
  id: PropTypes.any,
  disabled: PropTypes.bool
};

FormGroupCheckboxContent.className = 'checkbox';

FormGroupCheckboxContent.getClassName = getClassNameGenerator(FormGroupCheckboxContent.className);

FormGroupCheckboxContent.getContentTooltipAttrs = (id) => ({
  'data-tip': true,
  'data-for': `checkbox-label-tooltip${id}`
});

const FormGroup = ({
    label,
    labelClassName,
    isBoldLabel,
    isTopLabel,
    isRightHandLabel,
    elementId,
    labelSize,
    required,
    type,
    hint,
    children,
    className,
    tooltip
  }) => (
  <div className={
    classNames(
      FormGroup.className,
      {
        [FormGroup.getClassName('with-right-hand-label')]: isRightHandLabel,
        [FormGroup.getClassName('with-top-label')]: isTopLabel
      },
      className
    )
  }>
    <FormGroupLabel
      display-if={label}
      size={isTopLabel ? 12 : labelSize}
      isBold={isBoldLabel}
      required={required}
      elementId={elementId}
      className={classNames(FormGroup.getClassName('label'), labelClassName)}
      tooltip={tooltip}
    >{label}</FormGroupLabel>

    <FormGroupContent
      display-if={label}
      size={isTopLabel ? 12 : 12 - labelSize}
      className={FormGroup.getClassName('content')}
      hint={type !== 'checkbox' ? hint : null}
    >
      {
        type === 'checkbox'
          ? <FormGroupCheckboxContent hint={hint}>{children}</FormGroupCheckboxContent>
          : children
      }
    </FormGroupContent>

    {!label && (
      type === 'checkbox'
      ? <FormGroupCheckboxContent hint={hint}>{children}</FormGroupCheckboxContent>
      : children
    )}
  </div>
);

FormGroup.propTypes = {
  label: PropTypes.any,
  labelClassName: PropTypes.string,
  isBoldLabel: PropTypes.bool,
  isRightHandLabel: PropTypes.bool,
  isTopLabel: PropTypes.bool,
  elementId: PropTypes.string,
  labelSize: PropTypes.number,
  required: PropTypes.bool,
  type: PropTypes.string,
  hint: PropTypes.any,
  children: PropTypes.any,
  className: PropTypes.string,
  tooltip: PropTypes.any
};

FormGroup.defaultProps = {
  labelSize: 4
};

FormGroup.className = 'form-group';

FormGroup.getClassName = getClassNameGenerator(FormGroup.className);

export default FormGroup;
